import {checkLocationTaskTodoCanComplete} from '@src/modules/Locations/utils/check-location-task-todo-can-complete.ts'
import {RPCDocs} from '@therms/rpc-gateway'
import {useState} from 'react'
import {useInterval} from 'usehooks-ts'

export function useCanCompleteLocationTaskTodo(
  locationTaskTodo: Pick<
    RPCDocs.Locations.GetLocationTaskTodos.v1.LocationTaskTodo,
    'allowedLatest' | 'allowedEarliest' | 'dueDate' | 'status'
  >,
) {
  const [state, setState] = useState<
    ReturnType<typeof checkLocationTaskTodoCanComplete>
  >(() => checkLocationTaskTodoCanComplete(locationTaskTodo))

  const check = () => {
    setState(checkLocationTaskTodoCanComplete(locationTaskTodo))
  }

  useInterval(() => {
    check()
  }, 15_000)

  return state
}
